export const FILTER_SCHEMA_PROPERTY_TYPE = 'string';
